var map = {
	"./add-reaction.svg": "b5df",
	"./celebrate.svg": "3f2c",
	"./heart.svg": "15be",
	"./smile.svg": "e441",
	"./thumbs-up.svg": "290a",
	"./what.svg": "6162"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cd06";